import React, { useEffect } from "react";
import { claimService } from "../../../../api/services/claimService";
import { useAppSelector } from "../../../../infra/hooks";

interface PropsValue {
  setActionsOfLeaveEncash: (data: any) => void;
}
  const DTOLeaveARModal = ({ setActionsOfLeaveEncash }: PropsValue) => {
    const storedLeaveActions = useAppSelector(
      (state) => state.actionRequiredSlice.actionRequiredActions
    );
  
    useEffect(() => {
      if (storedLeaveActions) setActionsOfLeaveEncash(storedLeaveActions);
    }, []);



  return <></>;
};

export default DTOLeaveARModal;
